import actions from './actions';
import { createReducer } from '../../../../helpers/reducer';

const initState = {
  isLoading: false,
  isGrouped: false,
  sessions: {},
};

function onLoadSessionsActive(state) {
  return {
    ...state,
    isLoading: true,
  };
}

function onLoadSessionsActiveSuccess(state, { payload }) {
  return {
    ...state,
    isLoading: false,
    isGrouped: false,
    sessions: payload,
  };
}

function onLoadGroupSessionsActive(state) {
  return {
    ...state,
    isLoading: true,
  };
}

function onLoadGroupSessionsActiveSuccess(state, { payload }) {
  return {
    ...state,
    isLoading: false,
    isGrouped: true,
    sessions: payload,
  };
}

function onClearStore() {
  return { ...initState };
}

export default createReducer(initState, {
  [actions.LOAD_REQUEST]: onLoadSessionsActive,
  [actions.LOAD_SUCCESS]: onLoadSessionsActiveSuccess,
  [actions.LOAD_GROUP_REQUEST]: onLoadGroupSessionsActive,
  [actions.LOAD_GROUP_SUCCESS]: onLoadGroupSessionsActiveSuccess,
  [actions.CLEAR_STORE]: onClearStore,
});
